import { render, staticRenderFns } from "./LogoCard.vue?vue&type=template&id=12b3e570&scoped=true&"
import script from "./LogoCard.vue?vue&type=script&lang=js&"
export * from "./LogoCard.vue?vue&type=script&lang=js&"
import style0 from "./LogoCard.vue?vue&type=style&index=0&id=12b3e570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b3e570",
  null
  
)

export default component.exports